const LABELS = { personal: "Personal", team: "Team", all: "All ATL" };

export default function ScopeSwitch({ value, onChange, scopes }) {
  if (!scopes || scopes.length <= 1) return null;
  return (
    <div className="inline-flex items-center bg-white rounded-full border border-slate-200 p-1 shadow-sm" data-testid="scope-switch">
      {scopes.map((s) => {
        const active = value === s;
        return (
          <button
            key={s}
            data-testid={`scope-${s}`}
            onClick={() => onChange(s)}
            className={`px-3 py-1.5 text-sm rounded-full transition-colors ${
              active ? "bg-[#0A1F44] text-white" : "text-slate-600 hover:text-slate-900"
            }`}
          >
            {s === "team" && !scopes.includes("all") ? "My Team" : LABELS[s] || s}
          </button>
        );
      })}
    </div>
  );
}
